<template>
    <div id="contentcontainter" class="standard-mode">
        <!-- <a class="sr-only sr-only-focusable" href="#homeMain">Skip to main content</a> -->

        <v-dialog v-model="videodialog" max-width="800px" role="dialog" aria-modal="true" aria-labelledby="tutorial-video-title">
            <v-card v-focus-trap="videodialog">
                <v-card-title>
                    <h2 id="tutorial-video-title" class="sr-only">{{ videoDialogTitle }}</h2>
                    <v-btn class="mt-2" @click="videodialog = false" right absolute icon :aria-label="'Close dialog'"> <v-icon aria-hidden="true">mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="mt-4">
                    <div class="video-container">
                        <iframe
                            data-focus-first
                            tabindex="0"
                            style="border-radius: 10px"
                            width="560"
                            height="315"
                            :src="videoUrl"
                            :title="videoDialogTitle"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                </v-card-text>
                <v-card-action class="d-flex">
                    <v-btn class="ml-auto mb-2 mr-2" rounded color="primary" @click="videodialog = false">close</v-btn>
                </v-card-action>
            </v-card>
        </v-dialog>

        <div id="homeMain" role="main" aria-label="Homepage suites overview" style="max-width: 1800px; margin: auto">
            <v-row class="mt-5" no-gutters style="display: inline-flex">
                <v-card max-width="450px" class="mr-10 rounded_card quaroshadow transparent topboarder" aria-label="Welcome banner">
                    <v-card-text style="padding-top: 5px; padding-bottom: 5px">
                        <v-row>
                            <v-col class="">
                                <h1 class="my-2" style="font-family: 'CalSans', sans-serif">
                                    {{ titleUsername }}
                                </h1>

                                <p class="mb-3 mt-2" style="font-size: 16px; font-family: 'CalSans', sans-serif">{{ bannertext.firstp }}</p>
                                <div v-if="isOBI">
                                    <p style="background-color: #eeeeee; padding: 10px; border-radius: 15px">
                                        In our new version of Apollon you will find the Google Keyword Planner in the Research Suite. You can go directly to
                                        <a href="https://apollon.obi.com/searchvolume">Google Search Volume</a> to get the search volume of a list of keywords. Or you can use
                                        <a href="https://apollon.obi.com/ideas">Ideas</a> to get new keyword ideas.
                                    </p>
                                    <p style="background-color: #eeeeee; padding: 10px; border-radius: 15px">
                                        In the Monitoring Suite you will find OBI <a href="https://apollon.obi.com/monitoring">Visibility in Google for different keyword sets</a>. At the moment we
                                        provide the visibility of our online shop with the E-Com Index Germany. More indexes will follow!
                                    </p>
                                    <p style="background-color: #eeeeee; padding: 10px; border-radius: 15px">
                                        If you have any questions, please contact our Google support chat.
                                        <v-btn class="ml-2" x-small rounded color="primary" @click="openlink('https://chat.google.com/room/AAAAu4yTgFI?cls=7')" aria-label="Open Google support chat">
                                            <v-icon size="14px" class="mr-1" aria-hidden="true">mdi-message</v-icon> Chat
                                        </v-btn>
                                    </p>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card v-if="isOBI" max-width="450px" class="mr-auto rounded_card quaroshadow transparent topboarder" aria-label="Apollon onboarding information">
                    <v-card-text style="padding-top: 5px; padding-bottom: 5px">
                        <v-row>
                            <v-col class="">
                                <div>
                                    <h1 class="my-2 mb-3" style="font-family: 'CalSans', sans-serif">New to Apollon?</h1>
                                    <p style="background-color: #eeeeee; padding: 10px; border-radius: 15px">
                                        You can now access our general onboarding slides here. These explain the basic functions of the Keyword Ideas, Google Search Volume and Monitoring Suite
                                        modules.
                                    </p>
                                    <div class="d-flex">
                                        <img
                                            @click="openlink('https://go.obi.de/apollon-training-slides')"
                                            class="obislidesimg"
                                            height="200px"
                                            width="auto"
                                            src="../assets/obi_slides.png"
                                            alt="Cover image for Apollon training slides" />
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-row>
            <v-row class="mt-5" v-if="!isOBI">
                <v-col xs="12" sm="12" md="6" lg="3">
                    <v-card
                        :disabled="!$store.state.research_suite"
                        max-width="600px"
                        height="100%"
                        class="mr-auto rounded_card quaroshadow transparent"
                        style="overflow: hidden"
                        aria-label="Research Suite teaser">
                        <v-overlay style="z-index: 9" :value="isResearchDisabled" absolute aria-hidden="true">
                            <div class="text-center">
                                <v-btn rounded small color="primary" class="white--text" @click="$router.push('/pricing')" aria-label="Upgrade plan"> Upgrade Plan </v-btn>
                            </div>
                        </v-overlay>
                        <v-card-text>
                            <v-row no-gutters>
                                <v-col md="8" sm="8">
                                    <p style="line-height: 1; padding-left: 2px; margin-bottom: 6px; font-family: 'CalSans', sans-serif; font-weight: bold; font-size: 16px" class="text-primary">
                                        Research Suite
                                    </p>
                                    <h2 class="homecardtitle" style="line-height: 1; color: black; font-family: 'CalSans', sans-serif; font-weight: bold; font-size: 26px">Research Keywords</h2>

                                    <p class="mb-3">{{ researchText.firstp }}</p>
                                    <div class="btn-group-wrap mt-auto">
                                        <v-btn rounded color="grey" class="pl-2 mr-2" small @click="$router.push('/ideas')" aria-label="Open Research Suite">
                                            <v-icon small class="mr-1" aria-hidden="true">mdi-start</v-icon>
                                            Let´s go
                                        </v-btn>
                                        <v-btn
                                            outlined
                                            rounded
                                            color="grey"
                                            class="pl-2"
                                            small
                                            @click="
                                                videoUrl = videoUrls[1]
                                                videodialog = true
                                            "
                                            aria-label="Open Research Suite tutorial video">
                                            <v-icon small class="mr-1" aria-hidden="true">mdi-video</v-icon>
                                            tutorial
                                        </v-btn>
                                    </div>
                                </v-col>
                                <v-col md="4" sm="4" style="display: flex">
                                    <img style="transform: scaleX(-1)" width="150" class="mx-auto" src="../assets/undraw_searching.svg" alt="Illustration of person searching with magnifying glass" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col v-if="company_id !== '1710'" xs="12" sm="12" md="6" lg="3">
                    <v-card
                        :disabled="!$store.state.content_suite || ($store.state.company_status_content_suite != 'active' && $store.state.company_status_content_suite != 'testing')"
                        max-width="600px"
                        height="100%"
                        class="mr-auto rounded_card quaroshadow transparent"
                        style="overflow: hidden"
                        aria-label="Content Suite teaser">
                        <v-overlay :value="isContentDisabled" absolute aria-hidden="true">
                            <div class="text-center">
                                <v-btn rounded small color="primary" class="white--text" @click="$router.push('/pricing')" aria-label="Upgrade plan"> Upgrade Plan </v-btn>
                            </div>
                        </v-overlay>
                        <v-card-text>
                            <v-row no-gutters class="flex-grow-1">
                                <v-col md="8" sm="8" class="d-flex flex-column flex-grow-1">
                                    <p style="line-height: 1; padding-left: 2px; margin-bottom: 6px; font-family: 'CalSans', sans-serif; font-weight: bold; font-size: 16px" class="text-primary">
                                        Content Suite
                                    </p>
                                    <h2 class="homecardtitle" style="line-height: 1; color: black; font-family: 'CalSans', sans-serif; font-weight: bold; font-size: 26px">Create Content</h2>

                                    <p class="mb-3">{{ contenttext.firstp }}</p>

                                    <div class="btn-group-wrap mt-auto">
                                        <v-btn rounded color="grey" class="pl-2 mr-2" small @click="$router.push('/content-project/setup')" aria-label="Open Content Suite">
                                            <v-icon small class="mr-1" aria-hidden="true">mdi-start</v-icon>
                                            Let´s go
                                        </v-btn>
                                        <v-btn
                                            outlined
                                            rounded
                                            color="grey"
                                            class="pl-2"
                                            small
                                            @click="
                                                videoUrl = videoUrls[0]
                                                videodialog = true
                                            "
                                            aria-label="Open Content Suite tutorial video">
                                            <v-icon small class="mr-1" aria-hidden="true">mdi-video</v-icon>
                                            tutorial
                                        </v-btn>
                                    </div>
                                </v-col>
                                <v-col md="4" sm="4" style="display: flex">
                                    <img style="transform: scaleX(-1)" width="150" class="mx-auto" src="../assets/undraw_typewriter.svg" alt="Illustration of person typing on typewriter" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col v-if="company_id !== '1710'" xs="12" sm="12" md="6" lg="3">
                    <v-card
                        :disabled="!$store.state.monitoring_suite || ($store.state.company_status_monitoring_suite != 'active' && $store.state.company_status_monitoring_suite != 'testing')"
                        max-width="600px"
                        height="100%"
                        class="mr-auto rounded_card quaroshadow transparent"
                        style="overflow: hidden"
                        aria-label="Monitoring Suite teaser">
                        <v-overlay :value="isMonitoringDisabled" absolute aria-hidden="true">
                            <div class="text-center">
                                <v-btn rounded small color="primary" @click="$router.push('/pricing')" aria-label="Upgrade plan"> Upgrade Plan </v-btn>
                            </div>
                        </v-overlay>
                        <v-card-text>
                            <v-row no-gutters>
                                <v-col md="8" sm="8">
                                    <p style="line-height: 1; padding-left: 2px; margin-bottom: 6px; font-family: 'CalSans', sans-serif; font-weight: bold; font-size: 16px" class="text-primary">
                                        Monitoring Suite
                                    </p>
                                    <h2 class="homecardtitle" style="line-height: 1; color: black; font-family: 'CalSans', sans-serif; font-weight: bold; font-size: 26px">Rank Tracking</h2>

                                    <p class="mb-3">{{ monitoringtext.firstp }}</p>

                                    <div style="display: inline">
                                        <v-btn rounded color="grey" class="pl-2 mr-2" small @click="$router.push('/monitoring/setup')" aria-label="Open Monitoring Suite">
                                            <v-icon small class="mr-1" aria-hidden="true">mdi-start</v-icon>
                                            Let´s go
                                        </v-btn>
                                    </div>
                                </v-col>
                                <v-col md="4" sm="4" style="display: flex">
                                    <img style="transform: scaleX(-1)" width="150" class="mx-auto" src="../assets/undraw_setup_analytics.svg" alt="Illustration of person analyzing charts" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col v-if="company_id !== '1710'" xs="12" sm="12" md="6" lg="3">
                    <v-card :disabled="isAIDisabled" max-width="600px" height="100%" class="mr-auto rounded_card quaroshadow transparent" style="overflow: hidden" aria-label="AI Suite teaser">
                        <v-overlay :value="isAIDisabled" absolute aria-hidden="true">
                            <div class="text-center">
                                <v-btn rounded small color="primary" class="white--text" @click="$router.push('/pricing')" aria-label="Upgrade plan"> Upgrade Plan </v-btn>
                            </div>
                        </v-overlay>
                        <v-card-text>
                            <v-row no-gutters>
                                <v-col md="8" sm="8">
                                    <p style="line-height: 1; padding-left: 2px; margin-bottom: 6px; font-family: 'CalSans', sans-serif; font-weight: bold; font-size: 16px" class="text-primary">
                                        AI Suite
                                    </p>
                                    <h2 class="homecardtitle" style="line-height: 1; color: black; font-family: 'CalSans', sans-serif; font-weight: bold; font-size: 26px">{{ aiText.title }}</h2>

                                    <p class="mb-3">{{ aiText.firstp }}</p>

                                    <div style="display: inline">
                                        <v-btn rounded color="grey" class="pl-2 mr-2" small @click="$router.push('/ai-suite')" aria-label="Open AI Suite">
                                            <v-icon small class="mr-1" aria-hidden="true">mdi-start</v-icon>
                                            Let´s go
                                        </v-btn>
                                        <!-- <v-btn
                                            outlined
                                            rounded
                                            color="grey"
                                            class="pl-2"
                                            small
                                            @click="
                                                videoUrl = videoUrls[2] || videoUrls[0]
                                                videodialog = true
                                            "
                                            aria-label="Open AI Suite tutorial video">
                                            <v-icon small class="mr-1" aria-hidden="true">mdi-video</v-icon>
                                            tutorial
                                        </v-btn> -->
                                    </div>
                                </v-col>
                                <v-col md="4" sm="4" style="display: flex">
                                    <div class="mx-auto d-flex align-center" aria-hidden="true">
                                        <v-icon color="primary" style="transform: scaleX(-1)" size="64" aria-hidden="true">mdi-robot</v-icon>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    // import HelloWorld from "@/components/HelloWorld.vue"

    export default {
        name: "Home",
        components: {},
        data() {
            return {
                aiText: {
                    title: "AI Visibility Tracking",
                    subtitle: "AI Suite",
                    firstp: "Create, upload and monitor AI prompts and responses in one place."
                },
                videodialog: false,
                videoUrl: "https://www.youtube.com/embed/6J1xuj3LqPs",
                videoUrls: ["https://www.youtube.com/embed/6J1xuj3LqPs", "https://www.youtube.com/embed/JIwOqGzpBRU"],
                bannertext: {
                    title: "Hi",
                    firstp: "welcome back! What do you want to do today?"
                },
                researchText: {
                    title: "Research Keywords",
                    subtitle: "Research Suite",
                    firstp: "Find out what people are searching for on Google or other platforms!"
                },
                contenttext: {
                    title: "Create Content",
                    subtitle: "Content Suite",
                    firstp: "Create Content Briefings in seconds or write content with the SEO AI Editor!"
                },
                monitoringtext: {
                    title: "Rank Tracking",
                    subtitle: "Monitoring Suite",
                    firstp: "Monitor your rankings and keep a watch on your competitors in Google Search results!"
                }
            }
        },
        computed: {
            videoDialogTitle() {
                if (this.videoUrl === this.videoUrls[0]) return "Tutorial video Content Suite"
                if (this.videoUrl === this.videoUrls[1]) return "Tutorial video Research Suite"
                return "Tutorial video"
            },
            isAIDisabled() {
                const status = this.$store?.state?.company_status_ai_suite
                if (!status) return false
                return !(status === "active" || status === "testing")
            },
            isOBI() {
                return window.location.href.includes("apollon.obi.com")
            },
            isMonitoringDisabled() {
                return this.$store.state.company_status_monitoring_suite != "active" && this.$store.state.company_status_monitoring_suite != "testing"
            },
            isResearchDisabled() {
                return this.$store.state.company_status != "active" && this.$store.state.company_status != "testing" && this.$store.state.company_status != "free"
            },
            isContentDisabled() {
                return this.$store.state.company_status_content_suite != "active" && this.$store.state.company_status_content_suite != "testing"
            },
            titleUsername() {
                try {
                    console.log("username", localStorage.getItem("username"))
                    if (localStorage.getItem("username").length > 0) {
                        let username = this.CryptoJS.AES.decrypt(localStorage.getItem("username"), process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8).split(" ")[0]
                        return this.bannertext.title + " " + username + ","
                    } else {
                        return this.bannertext.title + ","
                    }
                } catch (error) {
                    return this.bannertext.title + ","
                }
            },
            company_id() {
                return this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
            }
        },
        methods: {
            openlink(link) {
                window.open(link, "_blank")
            }
        }
    }
</script>

<style>
    .btn-group-wrap {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px; /* Abstand horizontal + vertikal beim Umbrechen */
    }
    /* Vorhandene Margin-Utilities neutralisieren */
    .btn-group-wrap .v-btn {
        margin: 0 !important;
    }
    .obislidesimg {
        border-radius: 10px;
        border: 2px solid grey;
        max-width: 100%;
        height: auto;
        display: block;
        margin-bottom: 10px;
    }
    .obislidesimg:hover {
        cursor: pointer;
    }
    .text-primary {
        color: var(--v-primary-base) !important;
    }
    .topboarder {
        border-top: 4px solid var(--v-primary-base) !important;
    }
    #searchsheet {
        margin-top: -30px;
        margin-left: 5px;
        width: 30px;
        height: 30px;
    }
    .transparent {
        /* background-color: #ffffffa8; */
    }
    .theme--dark .homecardtitle {
        margin-bottom: 10px !important;
        color: white !important;
    }
    .homecardtitle {
        margin-bottom: 10px !important;
    }
    .video-container {
        position: relative;
        padding-bottom: 56.25%; /* 16:9 Ratio */
        height: 0;
        overflow: hidden;
    }

    .video-container iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .sr-only {
        position: absolute !important;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0 0 1px 1px);
        white-space: nowrap;
        border: 0;
    }
    .sr-only-focusable:focus {
        position: static !important;
        width: auto;
        height: auto;
        margin: 8px 0;
        padding: 6px 10px;
        background: #fff3cd;
        color: #000;
        border-radius: 6px;
        box-shadow: 0 0 0 3px rgba(255, 193, 7, 0.35);
    }
</style>
